import React from "react";
import styled from "styled-components";

// --- STYLED COMPONENTS ---

// Główny wrapper stopki
const FooterWrapper = styled.footer`
  background-color: #00205B; /* Granatowy z logotypu KOZIOŁKI */
  color: #d1d5db; /* jasnoszary tekst */
  padding: 3rem 1rem 1rem 1rem;
  margin-top: auto; /* Wypycha stopkę na dół, jeśli kontener ma display: flex i min-height: 100vh */
`;

// Kontener w środku
const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr;
  gap: 3rem;
  text-align: center;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
    text-align: left;
  }
`;

const Section = styled.div``;

const Title = styled.h4`
  color: #ffffff;
  font-weight: 700;
  margin-bottom: 1.2rem;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const ListItem = styled.li`
  margin: 0.6rem 0;

  a {
    color: #d1d5db;
    text-decoration: none;
    transition: color 0.3s ease;
    font-weight: 500;

    &:hover {
      color: #C8102E; /* Czerwony akcent nawiązujący do kolorów klubowych */
    }
  }
`;

const ContactText = styled.p`
  margin: 0.4rem 0;
  line-height: 1.6;
  font-size: 0.95rem;

  strong {
    color: #ffffff;
    font-size: 1.05rem;
  }
`;

const Copyright = styled.div`
  text-align: center;
  margin-top: 3rem;
  padding-top: 1.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 0.85rem;
  color: #9ca3af;
  letter-spacing: 0.5px;
`;


// --- KOMPONENT ---

export const Footer = () => {
  return (
    <FooterWrapper>
      <Container>
        {/* Logo i opis */}
        <Section>
          {/* Upewnij się, że nazwa pliku z nowym logo zgadza się ze ścieżką poniżej */}
          <img src="/logo_PTH.png" alt="Logo PTH Koziołki Poznań" style={{ height: "90px", marginBottom: "1rem" }} />
          <ContactText>
            Oficjalna strona Poznańskiego Towarzystwa Hokejowego PTH Koziołki. 
            Jesteśmy na lodzie od 2005 roku.
          </ContactText>
        </Section>

        {/* Nawigacja */}
        <Section>
          <Title>Nawigacja</Title>
          <List>
            <ListItem><a href="/">Home</a></ListItem>
            <ListItem><a href="/aktualnosci">Aktualności</a></ListItem>
            <ListItem><a href="/kim-jestesmy">Kim jesteśmy</a></ListItem>
            <ListItem><a href="/kontakt">Kontakt</a></ListItem>
          </List>
        </Section>

        {/* Kontakt */}
        <Section>
          <Title>Kontakt</Title>
          <ContactText><strong>PTH Koziołki</strong></ContactText>
          <ContactText>ul. Żelazka 1, Poznań, Poland</ContactText>
          <ContactText>kontakt@pth-hokej.pl</ContactText>
          
          {/* Miejsce na Social Media, jeśli w przyszłości będziesz chciał je włączyć */}
          {/* <div style={{ marginTop: '1rem', display: 'flex', gap: '15px' }}>
            <a href="#" style={{ color: '#fff', fontSize: '1.2rem' }}><i className="fab fa-facebook-f"></i></a>
            <a href="#" style={{ color: '#fff', fontSize: '1.2rem' }}><i className="fab fa-instagram"></i></a>
          </div> 
          */}
        </Section>
      </Container>

      {/* Prawa autorskie */}
      <Copyright>
        © 2026 PTH Koziołki – Wszelkie prawa zastrzeżone
      </Copyright>
    </FooterWrapper>
  );
};